import { createReducer, } from 'typesafe-actions';

import { fetchProductsAttributes, } from './actions';

const productsAttributesInitialState = {
    isLoading: false,
    isError: false,
    errorMessage: null,
    errorCode: null,
    data: null,
};

const productsAttributesReducer = createReducer(productsAttributesInitialState)
    .handleAction(fetchProductsAttributes.request, (state,) => ({ ...state, isLoading: true, }))
    .handleAction(fetchProductsAttributes.success, (state, action) => ({
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
    }))
    .handleAction(fetchProductsAttributes.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload.data ?? action.payload.message,
        errorCode: action.payload?.code,
    }));

export default productsAttributesReducer;
